export const saveFormData = formData => {
  return {
    type: 'SAVE_FORM_DATA',
    formData,
  }
}
